import * as PIXI from "pixi.js";
import Tween from "tween.ts";
import Animation from "./Animation";


export default class SwapSprite extends Animation {
  constructor(sprite: PIXI.Sprite | PIXI.Text, startScale: number, endScale: number, onComp = () => { }) {
    super();
    sprite.scale.set(startScale, Math.abs(startScale));
    sprite.visible = true;

    new Tween.Tween(sprite.scale)
      .to({ x: endScale, y: Math.abs(endScale) }, 300)
      .easing(Tween.Easing.Elastic.Out)
      .onComplete(() => onComp())
      .start();
  }
}